import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createCartoonWithDrawItem,
  getAllCartoonWithDrawsItems,
  getDataForEdit,
  deleteCartoonWithDrawItem,
  getBillListForVendor,
  getDataForAfterBill,
  adjustCartoonWithDrawItem,
} from "../../store/CartoonWithDraw/CartoonWithDrawSliceApi";

import {
  getAllVendorItems,
  getCartoonListItems,
} from "../../store/AppLevelApi/AppLevelApi";
import { cartoonWithDrawSliceAction } from "../../store/CartoonWithDraw/CartoonWithDrawSlice";
import { headTitle } from "../../utility/GetTableListName";
import MainComponent from "../Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsCartoonWithDraws } from "../../ConstantData/FormOptions";
//import constant form option to create duplicate field
import { AddMoreFormOptionsCartoonWithDraws } from "../../ConstantData/AddMoreFormOptions";
//importing inital form data to store value state
import { InitialCartoonWithDrawFormData } from "../../ConstantData/InitialData";
//imporint form data error

//for only adjusted form
import { ErrorCartoonWithDrawFormData } from "../../ConstantData/ErrorOption";
import { adjustedFormCartoonWithDraw } from "../../ConstantData/AdjustedFormOption";
import { InitialAdjustData } from "../../ConstantData/AdjustInitialData";

function CartoonWithDraw() {
  const [showOtherFormBtn, setShowOtherFormBtn] = useState(false); //for only adjust

  const [adjustInitialData, setAdjustInitialData] = useState(InitialAdjustData);

  let newFormOptionsCartoonWithDraw = JSON.parse(
    JSON.stringify(AddMoreFormOptionsCartoonWithDraws)
  );

  let newFormOptionsCartoonWithDrawText = JSON.parse(
    JSON.stringify(FormOptionsCartoonWithDraws)
  );
  let newAdjustedFormCartoonWithDraw = JSON.parse(
    JSON.stringify(adjustedFormCartoonWithDraw)
  );
  // let billDataList = useSelector((state) => state.cartoonWithDraw.billDataList);

  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getProductItems("name"));
    // dispatch(getAllCartoonWithDrawsItems());
    // dispatch(getAllVendorItems());
    // dispatch(getCartoonListItems());
  }, []);

  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const cartoonWithDrawList = useSelector(
    (state) => state.cartoonwithdraw.cartoonWithDrawList
  );
  console.log(cartoonWithDrawList);
  //for normal form input data initilization
  const InitialFormDataStore = useSelector(
    (state) => state.cartoonwithdraw.initialData
  );
  //for normal duplicate form input data initilization
  let InitialFormDuplicateDataStore = useSelector(
    (state) => state.cartoonwithdraw.initialDuplicateData
  );

  const cartoonWithDrawEditData = useSelector(
    (state) => state.cartoonwithdraw.dataEdit
  );
  let cartoonWithDrawFormError = useSelector(
    (state) => state.cartoonwithdraw.errorData
  );

  let isError = useSelector((state) => state.cartoonwithdraw.isError);
  cartoonWithDrawFormError = {
    ...ErrorCartoonWithDrawFormData,
    ...cartoonWithDrawFormError,
  };
  const vendorList = useSelector((state) => state.applevel.vendorList);
  const cartoonList = useSelector((state) => state.applevel.cartoonList);
  const billList = useSelector((state) => state.cartoonwithdraw.billList);

  function addOptionForSelectFieldDuplicate(
    FormOption,
    list,
    optionName,
    type
  ) {
    if (type === "duplicate") {
      newFormOptionsCartoonWithDraw = FormOption.map((item) => {
        if (item?.labelName === optionName) {
          item.options = list;
        }

        return item;
      });
    } else {
      newAdjustedFormCartoonWithDraw = adjustedFormCartoonWithDraw.map(
        (item) => {
          if (item?.labelName === optionName) {
            item.options = list;
          }

          return item;
        }
      );
    }
  }
  function addOptionForSelectField(FormOption, list, optionName) {
    newFormOptionsCartoonWithDrawText = FormOption.map((item) => {
      if (item?.labelName === optionName) {
        item.options = list;
      }

      return item;
    });
  }

  if (vendorList.length > 0) {
    // to chage subquality option coming from server4
    addOptionForSelectField(
      newFormOptionsCartoonWithDrawText,
      vendorList,
      "Vendor"
    );
  }

  if (cartoonList.length > 0) {
    // to chage product option coming from server
    addOptionForSelectFieldDuplicate(
      newFormOptionsCartoonWithDraw,
      cartoonList,
      "Cartoon Type",
      "duplicate"
    );
  }

  if (billList.length > 0) {
    // to chage product option coming from server
    addOptionForSelectFieldDuplicate(
      adjustedFormCartoonWithDraw,
      billList,
      "Bill Number",
      "adjusted"
    );
  } else {
    addOptionForSelectFieldDuplicate(
      adjustedFormCartoonWithDraw,
      [],
      "Bill Number",
      "adjusted"
    );
  }

  const setDataForAdjust = (type) => {
    if (vendorList.length > 0) {
      addOptionForSelectFieldDuplicate(
        adjustedFormCartoonWithDraw,
        vendorList,
        "Vendor",
        "adjusted"
      );
    }
  };

  const inputAdjustHandler = (name, value) => {
    //only for adjust not need for all

    const formData = JSON.parse(JSON.stringify(adjustInitialData)); //deep copy
    if (name === "bill_number") {
      setShowOtherFormBtn((prevState) => !prevState);
      // dispatch(getDataForAfterBill(value.value));
    }
    if (name === "vendor") dispatch(getBillListForVendor(value.value));
    formData[name] = value;
    setAdjustInitialData(formData);
  };

  const headTitleLabel = headTitle(FormOptionsCartoonWithDraws, [
    "Product",
    "Cartoon Quantity",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialCartoonWithDrawFormData}
      getDataForEdit={getDataForEdit}
      delteFun={deleteCartoonWithDrawItem}
      createFun={createCartoonWithDrawItem} //create function coming from store
      FormOptions={newFormOptionsCartoonWithDrawText}
      NewFormOptions={newFormOptionsCartoonWithDraw}
      OptionName="Create Cartoon WithDraw"
      OptionNameList="Cartoon WithDraw"
      generalList={cartoonWithDrawList}
      headTitle={headTitleLabel}
      EditData={cartoonWithDrawEditData}
      isError={isError}
      ErrorData={cartoonWithDrawFormError}
      InitialFormDataStore={InitialFormDataStore}
      InitialFormDuplicateDataStore={InitialFormDuplicateDataStore}
      setErrorData={cartoonWithDrawSliceAction.setErrorData}
      generalModuleList={vendorList} //list to add different module
      isNotDeleteBtn={true}
      extraAddBtn={true}
      extraButtonText={"Add Cartoon"}
      FormStyle={"!w-[60%] !h-[40rem] custom-scroll-for-nav overflow-y-scroll "}
      secondCreateBtn={false} // to create second button to add extra form
      isSuccess={isSuccess}
      needAdjust={true} //it is used if there is no edit but need adjust
      adjustedFormWithDraw={adjustedFormCartoonWithDraw} //it is used if there is no edit but need adjust
      setDataForAdjust={setDataForAdjust}
      inputAdjustHandler={inputAdjustHandler} //it is used if there is no edit but need adjust
      InitialAdjustData={adjustInitialData} //it is used if there is no edit but need adjust
      listForLength={{ billList }}
      showOtherFormBtn={showOtherFormBtn} // //it is used if there is no edit but need adjust
      createAdjust={adjustCartoonWithDrawItem}
      notShowEditBtn={true} //use when you dont need edit btn
    />
  );
}

export default CartoonWithDraw;
